export const CATEGORY_MENU = [
  {
    name: "Sale",
    slug: "/",
    href: "/",
  },
  {
    name: "Electronics",
    slug: "electronics",
    href: "/list?cat=electronics",
  },
  {
    name: "Home & Kitchen",
    slug: "home-and-kitchen",
    href: "/list?cat=home-and-kitchen",
  },
];

export const CATEGORY_SUB_MENU = [
  {
    name: "Discover Gifts",
    slug: "/gifts/discover-gifts",
    children: [
      {
        name: "See all gifts",
        slug: "/gifts/all",
      },
      {
        name: "New in gifts",
        slug: "/gifts/new",
      },
      {
        name: "Personalised gifts",
        slug: "/gifts/personalised",
      },
      {
        name: "Most wanted",
        slug: "/gifts/most-wanted",
      },
    ],
  },
  {
    name: "Gifts by Recipient",
    slug: "/gifts/by-recipient",
    children: [
      {
        name: "Gifts for her",
        slug: "/gifts/for-her",
      },
      {
        name: "Gifts for men",
        slug: "/gifts/for-men",
      },
      {
        name: "Gifts for mums",
        slug: "/gifts/for-mums",
      },
      {
        name: "Gifts for dads",
        slug: "/gifts/for-dads",
      },
      {
        name: "Gifts for babies",
        slug: "/gifts/for-babies",
      },
      {
        name: "Gifts for kids",
        slug: "/gifts/for-kids",
      },
      {
        name: "Gifts for teenagers",
        slug: "/gifts/for-teenagers",
      },
      {
        name: "Gifts for grandfathers",
        slug: "/gifts/for-grandfathers",
      },
      {
        name: "Gifts for grandmothers",
        slug: "/gifts/for-grandmothers",
      },
    ],
  },
  {
    name: "Gifts by Personality",
    slug: "/gifts/by-personality",
    children: [
      {
        name: "Gifts for gardeners",
        slug: "/gifts/for-gardeners",
      },
      {
        name: "Gifts for foodies",
        slug: "/gifts/for-foodies",
      },
      {
        name: "Gifts for frequent travellers",
        slug: "/gifts/for-travellers",
      },
      {
        name: "Gifts for book lovers",
        slug: "/gifts/for-book-lovers",
      },
      {
        name: "Gifts for aspiring chefs",
        slug: "/gifts/for-aspiring-chefs",
      },
      {
        name: "Gifts for music lovers",
        slug: "/gifts/for-music-lovers",
      },
      {
        name: "Gifts for pet owners",
        slug: "/gifts/for-pet-owners",
      },
      {
        name: "Gifts for craft lovers",
        slug: "/gifts/for-craft-lovers",
      },
      {
        name: "Gifts for wellness gurus",
        slug: "/gifts/for-wellness-gurus",
      },
    ],
  },
  {
    name: "Popular Gift Ideas",
    slug: "/gifts/popular-ideas",
    children: [
      {
        name: "Experience day gifts",
        slug: "/gifts/experience-day",
      },
      {
        name: "Subscription gifts",
        slug: "/gifts/subscription",
      },
      {
        name: "Photo gifts",
        slug: "/gifts/photo-gifts",
      },
      {
        name: "Hampers & gift sets",
        slug: "/gifts/hampers-gift-sets",
      },
      {
        name: "Chocolates & confectionery",
        slug: "/gifts/chocolates-confectionery",
      },
      {
        name: "Letterbox gifts",
        slug: "/gifts/letterbox",
      },
      {
        name: "Flower gifts",
        slug: "/gifts/flowers",
      },
      {
        name: "Gift cards",
        slug: "/gifts/gift-cards",
      },
    ],
  },
  {
    name: "Cards by Occasion",
    slug: "/cards/occasion",
    children: [
      {
        name: "Birthday cards",
        slug: "/cards/birthday",
      },
      {
        name: "Valentine's Day cards",
        slug: "/cards/valentines",
      },
      {
        name: "Wedding cards",
        slug: "/cards/wedding",
      },
      {
        name: "Anniversary cards",
        slug: "/cards/anniversary",
      },
      {
        name: "Christening cards",
        slug: "/cards/christening",
      },
      {
        name: "Engagement cards",
        slug: "/cards/engagement",
      },
      {
        name: "New baby cards",
        slug: "/cards/new-baby",
      },
      {
        name: "Congratulations cards",
        slug: "/cards/congratulations",
      },
      {
        name: "Get well soon cards",
        slug: "/cards/get-well-soon",
      },
    ],
  },
  {
    name: "Cards by Occasion 1",
    slug: "/cards/occasion",
    children: [
      {
        name: "Birthday cards",
        slug: "/cards/birthday",
      },
      {
        name: "Valentine's Day cards",
        slug: "/cards/valentines",
      },
      {
        name: "Wedding cards",
        slug: "/cards/wedding",
      },
      {
        name: "Anniversary cards",
        slug: "/cards/anniversary",
      },
      {
        name: "Christening cards",
        slug: "/cards/christening",
      },
      {
        name: "Engagement cards",
        slug: "/cards/engagement",
      },
      {
        name: "New baby cards",
        slug: "/cards/new-baby",
      },
      {
        name: "Congratulations cards",
        slug: "/cards/congratulations",
      },
      {
        name: "Get well soon cards",
        slug: "/cards/get-well-soon",
      },
    ],
  },
];

// export const navigationData = [
//     {
//         id: Math.floor(Math.random() * 100000),
//         label: "Link 1 (level 1)",
//         links: [
//             {
//                 id: Math.floor(Math.random() * 100000),
//                 label: "Link 1 (level 2)",
//                 links: [
//                     {
//                         id: Math.floor(Math.random() * 100000),
//                         label: "Link 1 (level 3)",
//                     },
//                     {
//                         id: Math.floor(Math.random() * 100000),
//                         label: "Link 2 (level 3)",
//                     },
//                     {
//                         id: Math.floor(Math.random() * 100000),
//                         label: "Link 3 (level 3)",
//                     },
//                 ],
//             },
//             {
//                 id: Math.floor(Math.random() * 100000),
//                 label: "Link 2 (level 2)",
//             },
//             {
//                 id: Math.floor(Math.random() * 100000),
//                 label: "Link 3 (level 2)",
//             },
//         ],
//     },
//     {
//         id: Math.floor(Math.random() * 100000),
//         label: "Link 2 (level 1)",
//         links: [
//             {
//                 id: Math.floor(Math.random() * 100000),
//                 label: "Link 1 (level 2)",
//                 links: [
//                     {
//                         id: Math.floor(Math.random() * 100000),
//                         label: "Link 1 (level 3)",
//                     },
//                     {
//                         id: Math.floor(Math.random() * 100000),
//                         label: "Link 2 (level 3)",
//                     },
//                     {
//                         id: Math.floor(Math.random() * 100000),
//                         label: "Link 3 (level 3)",
//                     },
//                 ],
//             },
//             {
//                 id: Math.floor(Math.random() * 100000),
//                 label: "Link 2 (level 2)",
//             },
//             {
//                 id: Math.floor(Math.random() * 100000),
//                 label: "Link 3 (level 2)",
//             },
//         ],
//     },
//     {
//         id: Math.floor(Math.random() * 100000),
//         label: "Link 3 (level 1)",
//         links: [
//             {
//                 id: Math.floor(Math.random() * 100000),
//                 label: "Link 1 (level 2)",
//                 links: [
//                     {
//                         id: Math.floor(Math.random() * 100000),
//                         label: "Link 1 (level 3)",
//                     },
//                     {
//                         id: Math.floor(Math.random() * 100000),
//                         label: "Link 2 (level 3)",
//                     },
//                     {
//                         id: Math.floor(Math.random() * 100000),
//                         label: "Link 3 (level 3)",
//                     },
//                 ],
//             },
//             {
//                 id: Math.floor(Math.random() * 100000),
//                 label: "Link 2 (level 2)",
//             },
//             {
//                 id: Math.floor(Math.random() * 100000),
//                 label: "Link 3 (level 2)",
//             },
//         ],
//     },
// ];
